import { BaseTheme } from "@swiggy-private/dls-web-common/dist/components/themes/Base";
import { DineoutTheme } from "@swiggy-private/dls-web-common/dist/components/themes/precomputed/Dineout/DineoutTheme";
import { InstamartTheme } from "@swiggy-private/dls-web-common/dist/components/themes/precomputed/Instamart/InstamartTheme";
import { ITheme } from "@swiggy-private/dls-web-common/dist/components/types";
import { isEmpty } from "@swiggy-private/js-utils";
import {
    AppColorMode,
    BASE_PROVIDER_THEME,
    DINEOUT_PROVIDER_THEME,
    DINEOUT_THEME_QUERY_VALUE,
    THEME_QUERY_PARAM,
} from "../constants/Theme";

type CollectionProviderTheme = typeof DINEOUT_PROVIDER_THEME | typeof BASE_PROVIDER_THEME;

export type AppThemeSelection = {
    theme: ITheme;
    providerTheme: CollectionProviderTheme;
    colorMode: AppColorMode;
};

/** Read theme query after mount — avoids window.location during first render (hydration). */
export function getThemeQuery({
    routerQuery,
    search,
}: {
    routerQuery?: Record<string, string | string[] | undefined>;
    search?: string | null;
}): string | string[] | undefined {
    const fromRouter = routerQuery?.[THEME_QUERY_PARAM];
    if (!isEmpty(fromRouter)) {
        return fromRouter;
    }

    if (isEmpty(search)) {
        return undefined;
    }

    const fromSearch = new URLSearchParams(search).get(THEME_QUERY_PARAM);
    return isEmpty(fromSearch) ? undefined : fromSearch;
}

export function resolveAppTheme({
    themeQuery,
    imShell = false,
}: {
    themeQuery?: string | string[] | null;
    imShell?: boolean;
}): AppThemeSelection {
    const themeName = Array.isArray(themeQuery) ? themeQuery[0] : themeQuery;

    if (!isEmpty(themeName) && themeName === DINEOUT_THEME_QUERY_VALUE) {
        return {
            theme: DineoutTheme,
            providerTheme: DINEOUT_PROVIDER_THEME,
            colorMode: AppColorMode.Light,
        };
    }

    if (imShell) {
        return {
            theme: InstamartTheme,
            providerTheme: BASE_PROVIDER_THEME,
            colorMode: AppColorMode.Light,
        };
    }

    return {
        theme: BaseTheme,
        providerTheme: BASE_PROVIDER_THEME,
        colorMode: AppColorMode.Light,
    };
}
